import { initTask } from "./core/";
import { LogInfo } from "./utils";
// const key = 'ZZ_LEGO_PERF_SYMBOL' // 供对外使用，比如用来 禁用默认发送埋点逻辑，人工手动发送
// window['ZZ_LEGO_PERF_SYMBOL'].forbidSendFmp() // 禁用默认发送性能埋点

var defaultOpt = {
  beforeSend: function beforeSend(data) {
    LogInfo('beforeSend', data);
  },
  onLcp: function onLcp(data) {
    // LogInfo('onLcp', JSON.parse(JSON.stringify(data)))
  },
  onFmp: function onFmp(data) {
    // LogInfo('onFmp', data)
  },
  needAjax: true,
  needSource: true,
  needImg: true
};
var legoPerf = function legoPerf() {
  var opts = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : defaultOpt;
  try {
    if (typeof window !== 'undefined') {
      initTask(opts);
    }
  } catch (err) {
    console.error(err);
  }
};
export default legoPerf;